import React, {FC} from 'react';
import {Check} from 'assets/exports';
import classNames from 'classnames';
import PriceDisplay from 'components/utils/PriceDisplay';

import * as styles from './styles.module.scss';

interface CardProps {
	className?: string;
	highlight?: string;
	title: string;
	description: string;
	prices: {
		button: string;
		single: Price;
		double: Price;
	}
	listItems?: string[];
	active?: boolean;
}

interface Price {
	price: string;
	text: string;
	onClick: () => void;
	loading?: boolean;
}

type PriceProps = Price & {button: string, single?: boolean};

export const PriceButton: FC<PriceProps> = ({price, text, button, single, onClick, loading}) => {
	return (
		<>
			<div className={styles.details}>
				<PriceDisplay
					price={parseFloat(price) || 0}
					isLoading={loading}
					className={styles.price}
				/>
				<span className={styles.smallGray}>{`${text}`}</span>
			</div>
			{single ? (
				<button className={styles.buttonFilled} onClick={onClick} disabled={loading}>
					{button}
				</button>
			) : (
				<button className={styles.buttonOutlined} onClick={onClick} disabled={loading}>
					{button}
				</button>
			)}
		</>
	);
};

export const PricingCard: FC<CardProps> = ({
	className,
	highlight,
	title,
	description,
	prices,
	listItems,
	active,
}) => {
	const {single, double} = prices;
	const ListItem: FC<{text: string}> = ({text}) => {
		return (
			<li><Check className={styles.check} />{text}</li>
		);
	};

	return (
		<div className={classNames({
			[styles.card]: true,
			[styles.active]: active,
			[className || '']: Boolean(className),
		})}>
			{highlight &&
				<span className={styles.highlight}>{highlight}</span>}

			<h2 className={styles.title}>{title}</h2>
			<p className={styles.description}>{description}</p>

			<PriceButton button={prices.button} {...single} single />
			<PriceButton button={prices.button} {...double} />

			{listItems && listItems.length > 0 && (
				<div className={styles.small}>
					<span>Why pick this option?</span>
					<ul>
						{listItems.map((l, i) => <ListItem text={l} key={i} />)}
					</ul>
				</div>
			)}
		</div>
	);
};
export default PricingCard;
